import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Pack\UpdatePackController::__invoke
* @see app/Http/Controllers/Pack/UpdatePackController.php
* @route '/api/pack/{pack}'
*/
const UpdatePackController = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdatePackController.url(args, options),
    method: 'put',
})

UpdatePackController.definition = {
    methods: ["put"],
    url: '/api/pack/{pack}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Pack\UpdatePackController::__invoke
* @see app/Http/Controllers/Pack/UpdatePackController.php
* @route '/api/pack/{pack}'
*/
UpdatePackController.url = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { pack: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { pack: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            pack: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        pack: typeof args.pack === 'object'
        ? args.pack.id
        : args.pack,
    }

    return UpdatePackController.definition.url
            .replace('{pack}', parsedArgs.pack.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Pack\UpdatePackController::__invoke
* @see app/Http/Controllers/Pack/UpdatePackController.php
* @route '/api/pack/{pack}'
*/
UpdatePackController.put = (args: { pack: string | number | { id: string | number } } | [pack: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdatePackController.url(args, options),
    method: 'put',
})

export default UpdatePackController